<script setup lang="ts">
import HSForm from '~/components/forms/HSForm.vue'
import UserCheckIcon from '~/assets/icons/user-check.svg'

const { $modal, $config } = useNuxtApp()

const MODAL_NAME = 'createAccount'
const formId = $config.public.hubspotCreateAccountFormId

const isSubmitted = ref(false)
const isSubmitting = ref(false)

const close = () => {
  $modal.close(MODAL_NAME)
  $modal.currentModule = null
}

const back = () => {
  $modal.open('login')
  $modal.close(MODAL_NAME)
}

const onReadyForm = () => {
  isSubmitted.value = false
  isSubmitting.value = false
}

const onSubmitted = () => {
  isSubmitted.value = true
  isSubmitting.value = false
}
const onBeforeSubmit = () => {
  isSubmitting.value = true
}

const getForm = () => {
  if ($modal.currentModule === MODULES.SPECIAL_ISSUES) {
    return $config.public.hubspotSpecialIssuesFormId
  }
  return formId
}
</script>

<template>
  <div class="create-account-form">
    <HSForm
      data-testid="create-account-form"
      class="md:overflow-y-auto md:order-none order-1 [&_.form-columns-0_.hs-richtext_a]:text-neutral [&_.form-columns-0_.hs-richtext_a]:font-semibold"
      :class="{
        'px-12 pt-10 pb-5': !isSubmitting,
      }"
      :show-privacy-policy-link="false"
      :form-id="getForm()"
      @on-ready="onReadyForm"
      @on-before-submit="onBeforeSubmit"
      @on-submitted="onSubmitted"
    >
      <template #success>
        <div class="flex flex-col justify-center items-center">
          <UserCheckIcon class="w-20 h-20 text-semantic-good" />
          <p class="mt-4 font-semibold text-center text-h6 flex flex-col">
            <span>Thank you for creating your free account.</span> <br />
            <span>You will receive your login details via email shortly.</span>
          </p>
          <BaseButton
            class="mt-14 w-full md:w-full h-[42px]"
            variant="primary"
            @click="close"
          >
            Close
          </BaseButton>
        </div>
      </template>

      <template #footer>
        <BaseButton
          v-if="!isSubmitting"
          data-testid="create-account-back-button"
          class="mt-2 w-full flex-shrink-0"
          variant="tertiary"
          @click="back"
        >
          Back
        </BaseButton>
      </template>
    </HSForm>
    <div class="relative order-none h-40 md:h-full flex-shrink-0">
      <img
        data-testid="create-account-image"
        class="w-full h-40 md:h-full absolute top-0 left-0 object-cover object-center"
        src="https://res.cloudinary.com/benchmarkminerals/image/upload/v1744056312/assets/login/recortada_qfq6do.png"
        alt="Create Account"
      />
    </div>
  </div>
</template>

<style scoped>
.create-account-form {
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: 1fr;
  gap: 0;
  height: 100%;
}

@media (width >= 768px) {
  .create-account-form {
    grid-template-columns: 1fr 262px;
  }
}
</style>
